
let viewgird = [
  {
    path: '/P_Maintenanceservices',
    name: 'P_Maintenanceservices',
    component: () => import('@/views/arkteam/case/p_maintenanceservices.vue')
  },
  {
    path: '/P_Project',
    name: 'p_project',
    component: () => import('@/views/arkteam/case/p_project.vue')
  }, {
    path: '/Sys_Log',
    name: 'sys_Log',
    component: () => import('@/views/system/Sys_Log.vue')
  },
  {
    path: '/Sys_User',
    name: 'Sys_User',
    component: () => import('@/views/system/Sys_User.vue')
  },
  {
    path: '/Sys_UserWY',
    name: 'Sys_UserWY',
    component: () => import('@/views/system/Sys_UserWY.vue')
  },
  {
    path: '/permission',
    name: 'permission',
    component: () => import('@/views/system/Permission.vue')
  },
  {
    path: '/Sys_Dictionary',
    name: 'Sys_Dictionary',
    component: () => import('@/views/system/Sys_Dictionary.vue')
  },
  {
    path: '/Sys_Role',
    name: 'Sys_Role',
    component: () => import('@/views/system/Sys_Role.vue')
  }, {
    path: '/Sys_Role1',
    name: 'Sys_Role1',
    component: () => import('@/views/system/Sys_Role1.vue')
  }
  , {
    path: '/Sys_DictionaryList',
    name: 'Sys_DictionaryList',
    component: () => import('@/views/system/Sys_DictionaryList.vue')
  }
  , {
    path: '/SellOrder',
    name: 'SellOrder',
    component: () => import('@/views/order/SellOrder.vue')
  }, {
    path: '/SellOrder2',
    name: 'SellOrder2',
    component: () => import('@/views/order/SellOrder2.vue')
  }, {
    path: '/SellOrder3',
    name: 'SellOrder3',
    component: () => import('@/views/order/SellOrder3.vue')
  }, {
    path: '/vSellOrderImg',
    name: 'vSellOrderImg',
    component: () => import('@/views/order/vSellOrderImg.vue')
  },
  {
    path: '/App_Appointment',
    name: 'App_Appointment',
    component: () => import('@/views/order/App_Appointment.vue')
  },
  {
    path: '/App_Appointment2', //二级表头
    name: 'App_Appointment2',
    component: () => import('@/views/order/App_Appointment2.vue')
  },
  {
    path: '/App_TransactionAvgPrice',
    name: 'App_TransactionAvgPrice',
    component: () => import('@/views/appmanager/App_TransactionAvgPrice.vue'),
    meta: {
      keepAlive: false
    }
  }
  , {
    path: '/App_Expert',
    name: 'App_Expert',
    component: () => import('@/views/appmanager/App_Expert.vue')
  }
  , {
    path: '/App_Expert2',
    name: 'App_Expert2',
    component: () => import('@/views/appmanager/App_Expert2.vue')
  }
  , {
    path: '/App_Transaction',
    name: 'App_Transaction',
    component: () => import('@/views/appmanager/App_Transaction.vue')
  }
  , {
    path: '/App_Transaction2',
    name: 'App_Transaction2',
    component: () => import('@/views/appmanager/App_Transaction2.vue')
  }, {
    path: '/App_ReportPrice',
    name: 'App_ReportPrice',
    component: () => import('@/views/appmanager/App_ReportPrice.vue')
  }, {
    path: '/App_News',
    name: 'App_News',
    component: () => import('@/views/appmanager/App_News.vue')
  }, {
    path: '/App_NewsEditor',
    name: 'App_NewsEditor',
    component: () => import('@/views/appmanager/App_NewsEditor.vue')
  }, {
    path: '/FormDesignOptions',
    name: 'FormDesignOptions',
    component: () => import('@/views/system/form/FormDesignOptions.vue')
  }, {
    path: '/FormCollectionObject',
    name: 'FormCollectionObject',
    component: () => import('@/views/system/form/FormCollectionObject.vue')
  }, {
    path: '/Sys_WorkFlow',
    name: 'Sys_WorkFlow',
    component: () => import('@/views/system/flow/Sys_WorkFlow.vue')
  }, {
    path: '/Sys_WorkFlowTable',
    name: 'Sys_WorkFlowTable',
    component: () => import('@/views/system/flow/Sys_WorkFlowTable.vue')
  }, {
    path: '/Sys_QuartzOptions',
    name: 'Sys_QuartzOptions',
    component: () => import('@/views/system/quartz/Sys_QuartzOptions.vue')
  }, {
    path: '/Sys_QuartzLog',
    name: 'Sys_QuartzLog',
    component: () => import('@/views/system/quartz/Sys_QuartzLog.vue')
  }, {
    path: '/Sys_Department',
    name: 'Sys_Department',
    component: () => import('@/views/system/system/Sys_Department.vue')
  }, {
    path: '/p_project',
    name: 'p_project',
    component: () => import('@/views/arkteam/case/p_project.vue')
  }, {
    path: '/p_projectYYW',
    name: 'p_projectYYW',
    component: () => import('@/views/arkteam/case/p_project.vue')
  }, {
    path: '/p_projectYJC',
    name: 'p_projectYJC',
    component: () => import('@/views/arkteam/case/p_project.vue')
  }, {
    path: '/p_projectYRJ',
    name: 'p_projectYRJ',
    component: () => import('@/views/arkteam/case/p_project.vue')
  }, {
    path: '/p_projectYZS',
    name: 'p_projectYZS',
    component: () => import('@/views/arkteam/case/p_project.vue')
  }, {
    path: '/p_projectAll',
    name: 'p_projectAll',
    component: () => import('@/views/arkteam/case/p_project.vue')
  }, {
    path: '/p_projectUnassigned',
    name: 'p_projectUnassigned',
    component: () => import('@/views/arkteam/case/p_project.vue')
  }, {
    path: '/p_maintenanceservices',
    name: 'p_maintenanceservices',
    component: () => import('@/views/arkteam/case/p_maintenanceservices.vue')
  }, {
    path: '/p_supportplan',
    name: 'p_supportplan',
    component: () => import('@/views/arkteam/case/p_supportplan.vue')
  }, {
    path: '/p_supportplanlist',
    name: 'p_supportplanlist',
    component: () => import('@/views/arkteam/case/p_supportplanlist.vue')
  }, {
    path: '/p_sparepartsplanlist',
    name: 'p_sparepartsplanlist',
    component: () => import('@/views/arkteam/case/p_sparepartsplanlist.vue')
  }, {
    path: '/p_sparepartsplan',
    name: 'p_sparepartsplan',
    component: () => import('@/views/arkteam/case/p_sparepartsplan.vue')
  }, {
    path: '/p_implementationplanlist',
    name: 'p_implementationplanlist',
    component: () => import('@/views/arkteam/case/p_implementationplanlist.vue')
  }, {
    path: '/p_implementationplan',
    name: 'p_implementationplan',
    component: () => import('@/views/arkteam/case/p_implementationplan.vue')
  }, {
    path: '/p_personnelreserveplanlist',
    name: 'p_personnelreserveplanlist',
    component: () => import('@/views/arkteam/case/p_personnelreserveplanlist.vue')
  }, {
    path: '/p_personnelreserveplan',
    name: 'p_personnelreserveplan',
    component: () => import('@/views/arkteam/case/p_personnelreserveplan.vue')
  },   {
    path: '/c_case',
    name: 'c_case',
    component: () => import('@/views/arkteam/case/c_caseAll.vue')
  },   {
    path: '/c_caseZS',
    name: 'c_caseZS',
    component: () => import('@/views/arkteam/case/c_caseZS.vue')
  }, {
    path: '/c_caseXJ',
    name: 'c_caseXJ',
    component: () => import('@/views/arkteam/case/c_caseXJ.vue')
  }, {
    path: '/c_caseMy',
    name: 'c_caseMy',
    component: () => import('@/views/arkteam/case/c_caseMy.vue')
  }, {
    path: '/c_caseMyCaseClosed',
    name: 'c_caseMyCaseClosed',
    component: () => import('@/views/arkteam/case/c_caseMyCaseClosed.vue')
  }, {
    path: '/c_case_visitN',
    name: 'c_case_visitN',
    component: () => import('@/views/arkteam/case/c_case_visitN.vue')
  }, {
    path: '/c_case_visitY',
    name: 'c_case_visitY',
    component: () => import('@/views/arkteam/case/c_case_visitY.vue')
  }, {
    path: '/c_caseZHGLB',
    name: 'c_caseZHGLB',
    component: () => import('@/views/arkteam/case/c_caseZHGLB.vue')
  }, {
    path: '/c_faultydivice',
    name: 'c_faultydivice',
    component: () => import('@/views/arkteam/case/c_faultydivice.vue')
  }, {
    path: '/c_diagnostic',
    name: 'c_diagnostic',
    component: () => import('@/views/arkteam/case/c_diagnostic.vue')
  }, {
    path: '/c_applyspareparts',
    name: 'c_applyspareparts',
    component: () => import('@/views/arkteam/case/c_applyspareparts.vue')
  }, {
    path: '/c_applysparepartslist',
    name: 'c_applysparepartslist',
    component: () => import('@/views/arkteam/case/c_applysparepartslist.vue')
  }, {
    path: '/c_logisticsinformation',
    name: 'c_logisticsinformation',
    component: () => import('@/views/arkteam/case/c_logisticsinformation.vue')
  }, {
    path: '/c_singlequote',
    name: 'c_singlequote',
    component: () => import('@/views/arkteam/case/c_singlequote.vue')
  }, {
    path: '/c_dispatch',
    name: 'c_dispatch',
    component: () => import('@/views/arkteam/case/c_dispatch.vue')
  }, {
    path: '/c_dispatchCaseClosed',
    name: 'c_dispatchCaseClosed',
    component: () => import('@/views/arkteam/case/c_dispatchCaseClosed.vue')
  }, {
    path: '/c_dispatchDetail',
    name: 'c_dispatchDetail',
    component: () => import('@/views/arkteam/case/c_dispatchDetail.vue')
  }, {
    path: '/c_dispatchfeedback',
    name: 'c_dispatchfeedback',
    component: () => import('@/views/arkteam/case/c_dispatchfeedback.vue')
  }, {
    path: '/c_dispatchtime',
    name: 'c_dispatchtime',
    component: () => import('@/views/arkteam/case/c_dispatchtime.vue')
  }, {
    path: '/c_dispatchzsdaichengjie',
    name: 'c_dispatchzsdaichengjie',
    component: () => import('@/views/arkteam/case/c_dispatchzsdaichengjie.vue')
  }, {
    path: '/c_dispatchDQD',
    name: 'c_dispatchDQD',
    component: () => import('@/views/arkteam/case/c_dispatchDQD.vue')
  }, {
    path: '/c_dispatchzsyichengjie',
    name: 'c_dispatchzsyichengjie',
    component: () => import('@/views/arkteam/case/c_dispatchzsyichengjie.vue')
  }, {
    path: '/c_dispatchzsyiwancheng',
    name: 'c_dispatchzsyiwancheng',
    component: () => import('@/views/arkteam/case/c_dispatchzsyiwancheng.vue')
  }, {
    path: '/c_dispatchZsyichengjieDetail',
    name: 'c_dispatchZsyichengjieDetail',
    component: () => import('@/views/arkteam/case/c_dispatchZsyichengjieDetail.vue')
  }, {
    path: '/c_dispatchZsyichengjieDetailReadonly',
    name: 'c_dispatchZsyichengjieDetailReadonly',
    component: () => import('@/views/arkteam/case/c_dispatchZsyichengjieDetailReadonly.vue')
  }, {
    path: '/p_inspection',
    name: 'p_inspection',
    component: () => import('@/views/arkteam/case/p_inspection.vue')
  }, {
    path: '/ProjectCaseCount',
    name: 'ProjectCaseCount',
    component: () => import('@/views/arkteam/statistiks/ProjectCaseCount.vue')
  }, {
    path: '/EngineerCaseCount',
    name: 'EngineerCaseCount',
    component: () => import('@/views/arkteam/statistiks/EngineerCaseCount.vue')
  },{
    path: '/DispatchCaseCount',
    name: 'DispatchCaseCount',
    component: () => import('@/views/arkteam/statistiks/DispatchCaseCount.vue')
  }, {
    path: '/EngineerSaturation',
    name: 'EngineerSaturation',
    component: () => import('@/views/arkteam/statistiks/EngineerSaturation.vue')
  },{
    path: '/oa_zzshouqianzhichi',
    name: 'oa_zzshouqianzhichi',
    component: () => import('@/views/arkteam/statistiks/OAzzshouqianzhichi.vue')
  },{
    path: '/OAzzshouqianzhichiDetail',
    name: 'OAzzshouqianzhichiDetail',
    component: () => import('@/views/arkteam/statistiks/OAzzshouqianzhichiDetail.vue')
  }, {
    path: '/MySaturation',
    name: 'MySaturation',
    component: () => import('@/views/arkteam/statistiks/MySaturation.vue')
  }, {
    path: '/EngineerSaturationDetail',
    name: 'EngineerSaturationDetail',
    component: () => import('@/views/arkteam/statistiks/EngineerSaturationDetail.vue')
  }, {
    path: '/ProjectCostJiaoFu',
    name: 'ProjectCostJiaoFu',
    component: () => import('@/views/arkteam/statistiks/ProjectCostJiaoFu.vue')
  }, {
    path: '/ProjectCostZhuChang',
    name: 'ProjectCostZhuChang',
    component: () => import('@/views/arkteam/statistiks/ProjectCostZhuChang.vue')
  }, {
    path: '/CaseCaigou',
    name: 'CaseCaigou',
    component: () => import('@/views/arkteam/case/c_caseCaigou.vue')
  }, {
    path: '/c_caseDetail',
    name: 'c_caseDetail',
    component: () => import('@/views/arkteam/case/c_caseAllDetail.vue')
  }, {
    path: '/c_caseMyDetail',
    name: 'c_caseMyDetail',
    component: () => import('@/views/arkteam/case/c_caseMyDetail.vue')
  }, {
    path: '/c_caseToCaigou',
    name: 'c_caseToCaigou',
    component: () => import('@/views/arkteam/case/c_caseToCaigou.vue')
  }, {
    path: '/sys_msgsignair',
    name: 'sys_msgsignair',
    component: () => import('@/views/arkteam/case/sys_msgsignair.vue')
  }, {
    path: '/p_projectDetail',
    name: 'p_projectDetail',
    component: () => import('@/views/arkteam/case/p_projectDetail.vue')
  }, {
    path: '/EngineerStatus',
    name: 'EngineerStatus',
    component: () => import('@/views/arkteam/statistiks/EngineerStatus.vue')
  }, {
    path: '/ProjectCostDeptStats',
    name: 'ProjectCostDeptStats',
    component: () => import('@/views/arkteam/statistiks/ProjectCostDeptStats.vue')
  },   {
    path: '/Sys_BZGS',
    name: 'Sys_BZGS',
    component: () => import('@/views/system/Sys_BZGS.vue')
  },   {
    path: '/Sys_KPIStandard',
    name: 'Sys_KPIStandard',
    component: () => import('@/views/system/Sys_KPIStandard.vue')
  },   {
    path: '/p_project_document',
    name: 'p_project_document',
    component: () => import('@/views/arkteam/case/p_project_document.vue')
  }, {
    path: '/k_knowledge',
    name: 'k_knowledge',
    component: () => import('@/views/arkteam/case/k_knowledge.vue')
  }    ,{
        path: '/p_projectoa',
        name: 'p_projectoa',
        component: () => import('@/views/arkteam/case/p_projectoa.vue')
    }    ,{
        path: '/c_stock_main',
        name: 'c_stock_main',
        component: () => import('@/views/arkteam/case/c_stock_main.vue')
    }    ,{
        path: '/c_stock_sub',
        name: 'c_stock_sub',
        component: () => import('@/views/arkteam/case/c_stock_sub.vue')
    }    ,{
        path: '/c_stock_main_detail',
        name: 'c_stock_main_detail',
        component: () => import('@/views/arkteam/case/c_stock_main_detail.vue')
    }]

export default viewgird
